/**
 * Debounce function.
 * @param {Function} action Action
 * @param {number} delay Delay time
 * @returns {Function}
 */
export function debounce(action, delay = 500) {
  let timer;

  return function debouncedFn(...args) {
    clearTimeout(timer);

    timer = setTimeout(() => {
      action.apply(this, args);
    }, delay);
  };
}
